var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveAndDeployModelOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 0.5V19.5L8.135 12.375L14.625 19.5V0.5H1.375Z",
    fill: "#272D55",
    stroke: "#272D55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 1.5H6.6C6.26863 1.5 6 1.76863 6 2.1V3.9C6 4.23137 6.26863 4.5 6.6 4.5H9.4C9.73137 4.5 10 4.23137 10 3.9V2.1C10 1.76863 9.73137 1.5 9.4 1.5Z",
    fill: "#AECDFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 2H6.6C6.54477 2 6.5 2.04477 6.5 2.1V3.9C6.5 3.95523 6.54477 4 6.6 4H9.4C9.45523 4 9.5 3.95523 9.5 3.9V2.1C9.5 2.04477 9.45523 2 9.4 2Z",
    stroke: "#AECDFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 8.5H2.6C2.26863 8.5 2 8.76863 2 9.1V10.9C2 11.2314 2.26863 11.5 2.6 11.5H5.4C5.73137 11.5 6 11.2314 6 10.9V9.1C6 8.76863 5.73137 8.5 5.4 8.5Z",
    fill: "#AECDFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 9H2.6C2.54477 9 2.5 9.04477 2.5 9.1V10.9C2.5 10.9552 2.54477 11 2.6 11H5.4C5.45523 11 5.5 10.9552 5.5 10.9V9.1C5.5 9.04477 5.45523 9 5.4 9Z",
    stroke: "#AECDFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 8.5H10.6C10.2686 8.5 10 8.76863 10 9.1V10.9C10 11.2314 10.2686 11.5 10.6 11.5H13.4C13.7314 11.5 14 11.2314 14 10.9V9.1C14 8.76863 13.7314 8.5 13.4 8.5Z",
    fill: "#AECDFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 9H10.6C10.5448 9 10.5 9.04477 10.5 9.1V10.9C10.5 10.9552 10.5448 11 10.6 11H13.4C13.4552 11 13.5 10.9552 13.5 10.9V9.1C13.5 9.04477 13.4552 9 13.4 9Z",
    stroke: "#AECDFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5V6.5",
    stroke: "#AECDFC",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5V8.5",
    stroke: "#AECDFC",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5V8.5",
    stroke: "#AECDFC",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.5H3.5",
    stroke: "#AECDFC",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveAndDeployModelOperationIcon);
export default __webpack_public_path__ + "static/media/SaveAndDeployModelOperationIcon.607a9d8cb0f43d6a679c2fb02b299e6f.svg";
export { ForwardRef as ReactComponent };